import React from 'react';
import { Link } from 'react-router-dom';
import { Share2, Gift, Coins, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

const ReferralLeaderboard = () => {
  const { t } = useTranslation();
  const cards = [
    { icon: Share2, color: '#0055FF', id: 'share' },
    { icon: Gift, color: '#8B5CF6', id: 'discount' },
    { icon: Coins, color: '#F59E0B', id: 'credits' },
  ];

  return (
    <section className="py-24 px-6" data-testid="referral-section">
      <div className="max-w-4xl mx-auto text-center">
        <span className="text-xs uppercase tracking-[0.2em] text-[#F59E0B] font-semibold">{t('referral.eyebrow')}</span>
        <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-medium tracking-tight mt-4 mb-4">
          {t('referral.title')}
        </h2>
        <p className="text-lg text-[#A1A1AA] max-w-2xl mx-auto mb-12">
          {t('referral.subtitle')}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {cards.map((card, i) => (
            <div
              key={card.id}
              className="bg-[#111111] border border-white/10 rounded-2xl p-6 text-center hover:border-white/20 transition-colors"
              data-testid={`referral-card-${i}`}
            >
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: card.color + '15' }}
              >
                <card.icon className="w-6 h-6" style={{ color: card.color }} />
              </div>
              <h3 className="font-['Outfit'] font-medium text-base mb-1">{t('referral.cards.' + card.id + '.title')}</h3>
              <p className="text-sm text-[#A1A1AA]">{t('referral.cards.' + card.id + '.desc')}</p>
            </div>
          ))}
        </div>

        <Link to="/dashboard">
          <Button
            className="bg-[#F59E0B] hover:bg-[#D97706] text-black font-medium rounded-full px-8 py-5 text-sm group"
            data-testid="referral-dashboard-cta"
          >
            {t('referral.cta')}
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default ReferralLeaderboard;
